export const isUndefined = <PotentialValueType = unknown>(inputValue: undefined | PotentialValueType): inputValue is undefined =>
  typeof inputValue === "undefined";

export const isDefined = <PotentialValueType = unknown>(inputValue: undefined | PotentialValueType): inputValue is PotentialValueType =>
  typeof inputValue !== "undefined";

export const isArray = <InputArrayContents = unknown>(inputValue: undefined | InputArrayContents | InputArrayContents[]): inputValue is InputArrayContents[] =>
  Array.isArray(inputValue);

